import { render, staticRenderFns } from "./PaginatedProductList.vue?vue&type=template&id=4c711980&"
import script from "./PaginatedProductList.vue?vue&type=script&lang=ts&"
export * from "./PaginatedProductList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports